import React from "react";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import EarningDetailsCardSection from "./EarningDetailsCardSection";
import EarningTicketListCommission from "./EarningTicketListCommission";
import Filter from "./Filter";

const EarningDetailsCommission = ({
  isError,
  isLoading,
  details,
  getDetails,
  setDetails,
  handleTimeSpan,
  timeSpanInput,
}) => {
  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-earning-detail-body">
        <Filter
          setDetails={setDetails}
          getDetails={getDetails}
          handleTimeSpan={handleTimeSpan}
          timeSpanInput={timeSpanInput}
          isShowDateFilter={false}
        />
        <EarningDetailsCardSection
          isError={isError}
          isLoading={isLoading}
          details={details}
        />
        <EarningTicketListCommission
          isError={isError}
          isLoading={isLoading}
          details={details}
          getDetails={getDetails}
        />
      </div>
    </MainComponentWrapper>
  );
};

export default EarningDetailsCommission;
